/**
 * 登录鉴权相关
 * @author lvwei<453627592@qq.com>
 * @date 2018-07-05
 *
 */
import { Storage, Axios } from '../tools.js'
import * as APIS from '../config.js'
import * as Skey from '@/config/storage.config.js'

/**
 * 根据token获取用户信息
 * @return {[type]} [description]
 */
export function tokens () {
  const requestUrl = APIS.apibase + APIS.tokens
  return new Promise((resolve, reject) => {
    Axios.post(requestUrl).then(response => {
      const data = response.data
      const expireDate = (new Date()).getTime() + 86400 * 29 * 1000
      Storage.set(Skey.SKEY_TOKEN, data.token, expireDate)
      Storage.set(Skey.SKEY_USERINFO, data.user, expireDate)
      resolve(data)
    }).catch(error => {
      const response = error.response
      if (response.status === 401) { // 同步退出
        spaStateSync({method: 'logout'})
      }
      reject(response)
    })
  })
}

/**
 * 同步登陆/退出
 * @param  {[type]} options.method [description]
 * @return {[type]}                [description]
 */
export function spaStateSync ({method}) {
  let requestUrl = APIS.apibase.replace(/api\//, '')
  if (method === 'login') {
    requestUrl += APIS.spalogin
  } else if (method === 'logout') {
    requestUrl += APIS.spalogout
  } else {
    return false
  }
  return Axios.post(requestUrl)
}



// WEBPACK FOOTER //
// ./src/util/api/modules/auth.js